/* Recupero informazioni utente - TEST GEOLOCALIZZAZIONE */
// Detect mobile (not used)
function is_touch_device() {
    return 'ontouchstart' in window        // works on most browsers 
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
}

(function (a) { (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) })(navigator.userAgent || navigator.vendor || window.opera);

// Detect viewport
function detect_user_info() {
    $('.user-info.viewport strong').html($(document).width());

    //if(is_touch_device()) {
    if (jQuery.browser.mobile) {
        $('.user-info.touch').addClass('mobile');

        var vp = $(document).width();
        var $device = $('.user-info.navigation span');

        if (vp >= 990) {
            $device.html('Tablet landscape');
        }
        else if ((vp >= 768) && (vp < 990)) {
            $device.html('Tablet portrait');
        }
        else {
            $device.html('Mobile');
        }
    }
    else {
        $('.user-info.touch').addClass('desktop');

        var vp = $(document).width();
        var $device = $('.user-info.navigation span');

        if (vp >= 1440) {
            $device.html('Large desktop');
        }
        else if ((vp >= 990) && (vp < 1440)) {
            $device.html('Normal desktop');
        }
        else {
            $device.html('Small desktop');
        }
    }
}

detect_user_info();

$(window).on("resize", function () {
    detect_user_info();
});

// Detect geolocation
function geoFindMe() {
    var coords = document.getElementById("coords");
    var gmaps = document.getElementById("gmaps");

    if (!navigator.geolocation) {
        coords.innerHTML = '<p clas="user-info">La geolocalizzazione non è supportata dal tuo browser</p>';
        return;
    }

    function success(position) {
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;

        coords.innerHTML = '<p class="user-info">Latitudine: ' + latitude + '° <br>Longitudine: ' + longitude + '°</p><p></p>';

        gmaps.innerHTML = '<p><a href="https://www.google.it/maps/place/' + latitude + ',' + longitude + '" target="_blank">Guarda su Google Maps</a></p>';

        // https://maps.googleapis.com/maps/api/geocode/json?address=45.45,9.13&key=AIzaSyD4xYdAR4C598m-DoI-Cfkv44BDM3QaCNM
        $.getJSON('https://maps.googleapis.com/maps/api/geocode/json?address=' + latitude + ',' + longitude + '&key=AIzaSyD4xYdAR4C598m-DoI-Cfkv44BDM3QaCNM', function (geocode) {
            var address = geocode.results[5].address_components;
            printZipCode(address[0].short_name, address[1].short_name);
        });
    }

    function error() {
        coords.innerHTML = '<p class="user-info">Impossibile calcolare la tua posizione</p>';
    }

    coords.innerHTML = '<p class="user-info">Locating…</p>';

    navigator.geolocation.getCurrentPosition(success, error);
}

function printZipCode(zip_code, city) {
    zip.innerHTML = '<p class="user-info">CAP: ' + zip_code + ' ' + city + '</p>';
}
/* Recupero informazioni utente - TEST GEOLOCALIZZAZIONE (end) */

/* Localizzazione utente */
function getUserInfo() {
    if (is_touch_device()) {
        $('.localizzazione-utente .prompt-desktop').hide();

        if (!navigator.geolocation) {
            $('.video-container .video-wrapper.video-jolly').show();
            return;
        }

        function localizzazione_success(position) {
            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;
            // console.log('https://maps.googleapis.com/maps/api/geocode/json?address=' + latitude + ',' + longitude + '&key=AIzaSyD4xYdAR4C598m-DoI-Cfkv44BDM3QaCNM');

            $.getJSON('https://maps.googleapis.com/maps/api/geocode/json?address=' + latitude + ',' + longitude + '&key=AIzaSyD4xYdAR4C598m-DoI-Cfkv44BDM3QaCNM', function (geocode) {
                if (geocode.length) {
                    var address = geocode.results[6].address_components;
                    // console.log('sn: ', address[0].short_name);

                    $('.video-container .video-wrapper.video-ir p span').html(address[0].short_name);
                    $('.video-container .video-wrapper.video-ir').show();
                    return;
                }
            });
        }

        function localizzazione_error() {
            $('.video-container .video-wrapper.video-jolly').show();
            return;
        }

        navigator.geolocation.getCurrentPosition(localizzazione_success, localizzazione_error);
    }
}

$(".test-on-top-page").on("click", function () {
    window.alleanza.util.scrollToTopPage();
});

$(document).on("ready", function () {
    getUserInfo();
});

// Prompt send ZIP code
$('.localizzazione-utente .prompt-desktop button.send-button').on('click', function () {
    $('.video-container .video-wrapper').hide();

    $('.video-container .video-wrapper.video-ir p span').html($('.localizzazione-utente input').val());
    $('.video-container .video-wrapper.video-ir').show();
});

// Prompt send ZIP code
$('.localizzazione-utente .prompt-desktop button.cancel-button').on('click', function () {
    $('.video-container .video-wrapper').hide();

    $('.video-container .video-wrapper.video-jolly').show();
});
/* Localizzazione utente (end) */

/* Button chips */
$('button.alleanza-chip').on('click', function () {
    $(this).toggleClass('active-chip');
});
/* Button chips */

/* Input text */
// During typing
$('body').on('input', '.alleanza-text-input input', function () {
    checkInputTextValue($(this));
});

$('body').on('click', '.alleanza-text-input label', function () {
    $(this).siblings('input').get(0).focus();
});

// info commerciali chiusura slide
$(".info-commerciali a.trigger-close").on("click", function (e) {
    let that = $(this).closest(".info-commerciali");
    if (that.hasClass("slidedown")) {
        that.removeClass("slidedown");
        that.addClass("slideup");
    }
});

// close cookie bar
$(".cookie-bar a.action-menu-trigger, .cookie-bar a.alleanza-button").on("click", function (e) {
    if (!$(".cookie-bar").hasClass("hidden")) {
        $(".cookie-bar").addClass("hidden");
    }
});

// checkbox .ricerca-copertura-assicurativa che mostrano i form corrispondenti
$(".ricerca-copertura-assicurativa .alleanza-radio-container .alleanza-radio input").on("change", function (e) {
    if ($(this).hasClass("is_delegato")) {
        if (!$(".ricerca-copertura-assicurativa .box-richiedente").hasClass("hidden")) {
            $(".ricerca-copertura-assicurativa .box-richiedente").addClass("hidden");
        }
        $(".ricerca-copertura-assicurativa .box-delegato").removeClass("hidden");
    } else {
        if (!$(".ricerca-copertura-assicurativa .box-delegato").hasClass("hidden")) {
            $(".ricerca-copertura-assicurativa .box-delegato").addClass("hidden");
        }
        $(".ricerca-copertura-assicurativa .box-richiedente").removeClass("hidden");
    }
});

// Check the text
function checkInputTextValue($input) {
    if ($input.val() != '') {
        $input.addClass('is-dirty');
    }
    else {
        $input.removeClass('is-dirty');
    }
}

//refresh page on browser resize
// $(window).on('resize', function(e){
//     if (window.RT) clearTimeout(window.RT);
//         window.RT = setTimeout(function(){
//             this.location.reload(false); /* false to get page from cache */
//         }, 200);
// });

// Landing on page
$('.alleanza-text-input input').each(function (i, input) {
    checkInputTextValue($(input));
});

// Simulation of validation
$('.design-system button.simulate-success').on('click', function () {
    $(this).closest('.validation').find('.alleanza-text-input').removeClass('validation-error').addClass('validation-success');
});

$('.design-system button.simulate-error').on('click', function () {
    $(this).closest('.validation').find('.alleanza-text-input').removeClass('validation-success').addClass('validation-error');
});
/* Input text (end) */

/* Cards */
// Follow the link on click
ProductCardBindClickEvent();
function ProductCardBindClickEvent() {
    $('.product-card, .banner-cards--card').on('click', function (e) {
        $('.product-card, .banner-cards--card').removeClass("state-active");
        var href = $(this).find('.discover-more a').attr('href');
        $(this).addClass("state-active");
        window.location.href = href;
    });
}
/* Cards (end) */

/* Link section */
$('.link-section button').on('click', function (e) {
    var href = $(this).attr('href');
    window.location.href = href;
});
/* Link section (end) */

/* Tab toggle start*/
$('.tab-toggle input').on("click", function () {
    let parent = $(this).closest(".tab-toggle");
    if (this.checked) {
        parent.find(".scelta2").addClass("active");
        parent.find(".scelta1").removeClass("active");
    } else {
        parent.find(".scelta1").addClass("active");
        parent.find(".scelta2").removeClass("active");
    }
});
/* Tab toggle end*/

// /*Start table generica*/
// // Calcola il width automatico in base alla quantità di colonne
// $(".contenuto-generico table.tbl-generic").ready(function() {
//     let rows = $('table.tbl-generic tr th');
//     let lung = $("table.tbl-generic").width();
//     rows.width(lung/rows.length);
// });
// /*End table generica*/

/* href dropdown */
$('.alleanza-select-container .dropdown-item').on('click', function (e) {
    if ($(this).attr("href")) {
        window.location.href = $(this).attr("href");
    }
});

/* Pagination */
// Init
function initPagination() {
    $('.alleanza-pagination ul li.button-prev button').prop('disabled', 'disabled');
    $('.alleanza-pagination ul li.page').eq(0).addClass('active');
}

initPagination();
/* Pagination (end) */

/* Modals */
// Open modal
$('.open-alleanza-modal').on('click', function (e) {
    e.preventDefault();
    $(this).blur();

    var modal = $(this).data('alleanza-modal');

    $('body').addClass('alleanza-modal-opened');
    $('#' + modal).show();
});

// Close modal
$('.close-alleanza-modal').on('click', function (e) {
    e.preventDefault();
    $(this).blur();

    $('body').removeClass('alleanza-modal-opened');
    $(this).closest('.alleanza-modal').hide();
});
/* Modals (end) */